import React from "react";
import SalesWrapperList from "../SalesOrderList/SalesWrapperList";
import SalesWrapList from "../SalesOrderList/SalesWrapList";

interface ISalesOrdersProps {

}

const SalesOrders = (props:ISalesOrdersProps) => {

    return (
        <SalesWrapList />

        // <div className="min-h-screen bg-gray-50 flex flex-col">

        //     <div className="gap-4 grid h-full w-full p-4">
    
        //         <div className="bg-gray h-full">
        //             <div className="mx-auto max-w-screen-2xl h-full">
                        
        //                 <div className="w-full">
        //                     {/* <SalesWrapperList /> */}
        //                     <SalesWrapList />
        //                 </div>

        //             </div>
        //         </div>
        //     </div>
           
        // </div>
    )
};

export default SalesOrders;
